exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close-btn[data-v-520b99a9]{background-color:transparent}.close-btn[data-v-520b99a9]:after,.close-btn[data-v-520b99a9]:before{content:\"\";position:absolute;top:50%;left:50%;width:14px;height:2px;background-color:#fff;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.close-btn[data-v-520b99a9]:before{-webkit-transform:translate(-50%,-50%) rotate(45deg);transform:translate(-50%,-50%) rotate(45deg)}.close-btn[data-v-520b99a9]:after{-webkit-transform:translate(-50%,-50%) rotate(-45deg);transform:translate(-50%,-50%) rotate(-45deg)}", ""]);

// exports
